import Vue from 'vue';
import Vuex from 'vuex';
import userMutations from './modules/user/mutations';
import chatsMutations from './modules/chats/mutations';
import chatsGetters from './modules/chats/getters';
import notifyMutations from './modules/notify/mutations';
import developActions from './modules/develop/actions';
import developMutations from './modules/develop/mutations';
import usersMutations from './modules/users/mutations';

Vue.use(Vuex);

const data = {
  modules: {
    user: {
      loggedIn: false,
      errorsLogin: [],
      errorsCommon: [],
      id: null,
      email: null,
      is_email_confirmed: null,
      avatar_url: null,
      first_name: null,
      last_name: null,
      slug: null,
      kyc_status: null,
      kyc_retry: null,
      kyc_reject_type: null,
      kyc_reason: null,
      is_banned: null,
      is_2fa_enabled: null,
      is_moderator: null,
      is_administrator: null,
      is_employee: null,
      language_id: null,
      currency_id: null,
      created_at: null,
      contacts: [],
      messageSentErrors: null,
      grouChatCreationErrors: null
    },
    chats: {
      reconnectionAttempts: 0,
      recentChats: [],
      recentChatsMeta: {
        from: null,
        next_page: null,
        per_page: null
      },
      activeChatId: null,
      activeChat: null,
      activeChatMessages: null,
      activeChatMetaFrom: {
        from: null,
        next_page: null,
        per_page: null
      },
      activeChatMetaTo: {
        to: null,
        next_page: null,
        per_page: null
      },
      activeChatUsers: null,
      activeChatFirstUnread: null,
      unreadMessagesCount: {},
      requestingMessagesChatId: null
    },
    notify: {
      WSauth: false,
      WSopen: false,
      WSunreadNotifications: []
    },
    users: {
      lastActivity: {}
    },
    develop: {
      active: false
    }
  }
};

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    user: {
      namespaced: true,
      state: data.modules.user,
      mutations: userMutations
    },
    chats: {
      namespaced: true,
      state: data.modules.chats,
      mutations: chatsMutations,
      getters: chatsGetters
    },
    notify: {
      namespaced: true,
      state: data.modules.notify,
      mutations: notifyMutations
    },
    users: {
      namespaced: true,
      state: data.modules.users,
      mutations: usersMutations
    },
    develop: {
      namespaced: true,
      state: data.modules.develop,
      actions: developActions,
      mutations: developMutations
    }
  }
});

export default store;
